import type { IOrgProjectLocationRepository } from '../repositories/IOrgProjectLocationRepository.js';
import type { ProjectLocationEntity } from '../entities/OrgLocationEntity.js';

interface Deps { orgProjectLocationRepository: IOrgProjectLocationRepository; }

export function createListProjectLocationsUseCase({ orgProjectLocationRepository }: Deps) {
  return async function listProjectLocations(projectId: string): Promise<ProjectLocationEntity[]> {
    return orgProjectLocationRepository.listByProject(projectId);
  };
}
